import { fetchContent, fetchAllPagedContent } from '@utils/contentfulHelpers';
import logger from '@utils/logger';

export const userHasAccess = (promo, userContext) => {
  if (promo.contentTypeId !== 'userSpecificPromo') {
    return true;
  }
  const { isLoggedIn, profile } = userContext;

  const userStatus = {
    gold: profile.subscription === 'gold',
    registered: isLoggedIn,
    underage: profile.underage,
    sorted: profile.hogwartsHouse !== null,
    hasWand: profile.wand !== null,
    patronus: profile.patronusName !== null,
    hasAvatar: !!profile?.avatar?.avatarId,
  };

  let userCanAccess = true;
  Object.keys(userStatus).forEach((conditionName) => {
    const promoBoolValue = promo?.[conditionName];
    const userBoolValue = userStatus?.[conditionName];

    if (
      promoBoolValue !== undefined &&
      ((promoBoolValue && !userBoolValue) || (!promoBoolValue && userBoolValue))
    ) {
      userCanAccess = false;
    }
  });

  return userCanAccess;
};

export const fetchAllProfileContent = async () => {
  const contentFetchPromises = [];
  let profileContent = null;

  contentFetchPromises.push(
    fetchContent({
      contentTypes: ['wandIndex'],
      externalId: 'default-wand-index',
    }),
  );
  contentFetchPromises.push(
    fetchAllPagedContent({
      contentTypes: ['wandImage'],
    }),
  );
  contentFetchPromises.push(
    fetchAllPagedContent({
      contentTypes: ['patronus'],
    }),
  );
  contentFetchPromises.push(
    fetchContent({
      contentTypes: ['configuration'],
      externalId: 'user-interest-list',
    }),
  );

  try {
    const contentResponses = await Promise.all(contentFetchPromises);

    // Trim down the wand and patronus image data down to a simpler, direct mapping of
    // externalId to content body.
    const wandImages = contentResponses?.[1]?.[0]?.reduce((imagesObject, image) => {
      // eslint-disable-next-line no-param-reassign
      imagesObject[image.body.externalId] = image.body;
      return imagesObject;
    }, {});
    const patronusImages = contentResponses?.[2]?.[0]?.reduce((imagesObject, image) => {
      // eslint-disable-next-line no-param-reassign
      imagesObject[image.body.externalId] = image.body;
      return imagesObject;
    }, {});

    const userInterestsConfigResponse = (contentResponses?.[3]?.[0] || []).map((item) => item.body);

    profileContent = {
      wandIndex: contentResponses[0][0][0]?.body || {},
      wandImages: wandImages || {},
      patronusImages: patronusImages || {},
      userInterestsData:
        userInterestsConfigResponse[0]?.values.map((item) => item.dynamicValue) || [],
    };
  } catch (e) {
    logger('Error retrieving profile page content: ', e);
  }

  return profileContent;
};

export const resetProfilePagePosition = () => {
  window.scrollTo(0, 0);
};

export default { userHasAccess, fetchAllProfileContent };
